import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { CheckboxField } from './../../../../../../components/fields';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAuthorizationContent } from './assets/authorization';
import Signature from '../../../../../../components/signature';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { sign, getSignatures } from '../../../../../../reducers/signatures';
import { getUserBackgroundChecks, saveUserBackgroundCheck, updateBackgroundCheck, launchBackgroundCheck } from '../../../../../../reducers/backgroundCheck';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';

class BackgroundCheckAuthorizationStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'BackgroundCheckAuthorizationStep' } });

        const { role, job, userId, getSignatures, setProgressionProperties, backgroundCheck, getUserBackgroundChecks, saveUserBackgroundCheck } = this.props;
        const { auth_signed, consumer_copy_requested } = backgroundCheck;

        const createBackgroundCheckIfMissing = response =>
            response.length === 0 && saveUserBackgroundCheck(userId, job.id, { auth_signed, consumer_copy_requested });

        if (!backgroundCheck.id) {
            getUserBackgroundChecks(userId, createBackgroundCheckIfMissing);
        }

        getSignatures(role, result =>
            setProgressionProperties({
                agreementBGAuthorization: result.find(s => s.name === `${Signatures.types.BG_CHECK_AUTHORIZATION.name}:${job.id}`) !== undefined
            })
        );
    }

    submit({ acknowledgeAuthorizationGetCopy }, action) {
        const { role, job, backgroundCheck, sign, setProgressionProperties, updateBackgroundCheck, launchBackgroundCheck } = this.props;
        const { auth_signed, consumer_copy_requested } = backgroundCheck;

        if (!auth_signed) {
            sign(role, `${Signatures.types.BG_CHECK_AUTHORIZATION.name}:${job.id}`, ({ id }) => {
                setProgressionProperties({ agreementBGAuthorization: true });

                updateBackgroundCheck(backgroundCheck.id, { auth_signed: id, consumer_copy_requested: acknowledgeAuthorizationGetCopy }, () => {
                    launchBackgroundCheck(backgroundCheck.id, undefined);
                    action();
                });
            });

            return;
        }

        const requestCopyUpdated = consumer_copy_requested !== acknowledgeAuthorizationGetCopy;
        if (auth_signed && requestCopyUpdated) {
            updateBackgroundCheck(backgroundCheck.id, { consumer_copy_requested: acknowledgeAuthorizationGetCopy }, action);

            return;
        }

        action();
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, job, isCopyRequested, progression } = this.props;
        if (!progression || progression.agreementBGAuthorization === undefined) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'onboard2.backgroundCheckAuthorization.intro'} defaultMessage={'Authorization'} tagName={'h5'} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled">{getAuthorizationContent()}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Field
                            name="acknowledgeAuthorizationGetCopy"
                            component={CheckboxField}
                            checked={isCopyRequested === true}
                            placeholder={messages.acknowledgeAuthorizationGetCopy}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.BG_CHECK_AUTHORIZATION.name}:${job.id}`} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

BackgroundCheckAuthorizationStep = reduxForm(formSettings)(BackgroundCheckAuthorizationStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    const backgroundCheck = state.backgroundCheck.current;
    const profile = state.identity.profile;

    return {
        role: state.identity.role,
        job: state.onboarding.job,
        progression,
        isCopyRequested: selector(state, 'acknowledgeAuthorizationGetCopy') && selector(state, 'acknowledgeAuthorizationGetCopy') === true,
        backgroundCheck,
        initialValues: {
            acknowledgeAuthorizationGetCopy: backgroundCheck.consumer_copy_requested
        },
        userId: profile ? profile.id : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change,
            getSignatures: getSignatures,
            sign: sign,
            setProgressionProperties: setProgressionProperties,
            getUserBackgroundChecks,
            saveUserBackgroundCheck,
            updateBackgroundCheck,
            launchBackgroundCheck
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheckAuthorizationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/backgroundCheckAuthorization.jsx